module.exports = __webpack_public_path__ + "static/media/ci-sin-chip-folio.fee5646f.mp4";